import type { HeatDemandData, HeatLossIntensityBand } from './types';

const FORM_SCORE: Record<HeatDemandData['dwellingForm'], number> = {
  detached: 2,
  bungalow: 2,
  'semi-detached': 1,
  'end-terrace': 1,
  'mid-terrace': 0,
  'flat-top': 0,
  'flat-mid': -1,
  unknown: 0,
};

const ERA_SCORE: Record<HeatDemandData['fabricEra'], number> = {
  'pre-1919': 3,
  '1919-1944': 2,
  '1945-1964': 2,
  '1965-1980': 1,
  '1981-1995': 1,
  '1996-2006': 0,
  '2007-2013': -1,
  '2013-present': -2,
  unknown: 0,
};

const RETROFIT_SCORE: Record<HeatDemandData['retrofitLevel'], number> = {
  none: 1,
  partial: 0,
  full: -1,
  unknown: 0,
};

const CONSTRUCTION_SCORE: Record<HeatDemandData['constructionArchetype'], number> = {
  standard: 0,
  'timber-frame': -1,
  'concrete-panel': 1,
  prefab: 2,
  'park-home': 3,
  'solid-wall': 1,
  unknown: 0,
};

const BEDROOM_SCORE: Record<string, number> = {
  '1': -2,
  '2': -1,
  '3': 0,
  '4': 1,
  '5': 2,
  '6+': 3,
};

export function deriveHeatLossBandFromKw(kw: number): HeatLossIntensityBand {
  if (kw < 8) return 'low';
  if (kw < 14) return 'medium';
  if (kw < 20) return 'high';
  return 'very-high';
}

export function deriveHeatLossBand(input: HeatDemandData): HeatLossIntensityBand {
  // Manual entry takes highest authority — bypasses all inference requirements
  if (input.knownHeatLossKw !== undefined && input.knownHeatLossKw > 0) {
    return deriveHeatLossBandFromKw(input.knownHeatLossKw);
  }

  if (input.dwellingForm === 'unknown' || input.fabricEra === 'unknown' || !input.bedrooms) {
    return 'unknown';
  }

  const score =
    FORM_SCORE[input.dwellingForm] +
    ERA_SCORE[input.fabricEra] +
    RETROFIT_SCORE[input.retrofitLevel] +
    CONSTRUCTION_SCORE[input.constructionArchetype] +
    (BEDROOM_SCORE[input.bedrooms] ?? 0);

  if (score <= -2) return 'very-low';
  if (score <= 0) return 'low';
  if (score <= 3) return 'medium';
  if (score <= 6) return 'high';
  return 'very-high';
}

